var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoadingAxiosState || _vm.getLoadingState)?_c('div',[_c('div',{staticClass:"_loading-overflow"}),_c('div',{staticClass:"_loading-content"},[_c('div',{staticClass:"_loading-wrap"},[_c('lottie',{staticStyle:{"transform":"scale(2)"},attrs:{"options":_vm.defaultOptions}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }